<div class="profile-management-container">
  <div class="header-container">
    <div class="buttons-container">
     @if (isUserManagementAble) {
        <!-- <ds-button [text]="'buttons.share_profile' | translate" [width]="'small'" [styleType]="'empty-main'" (click)="share()"></ds-button> -->
        <ds-button
          class="button-new-profile"
          [iconRight]="'/public/assets/images/plus-circle.svg'"
          [text]="'buttons.new_profile' | translate"
          [width]="'small'"
          (click)="create()"
        ></ds-button>
     } 
    </div>
  </div>
  <div class="content-container">
    <app-appointments-table
      [isFrom]="'private-area'"
      (actionClicked)="switchProfile($event)"
      (emitDeleteAction)="updateUsers($event)"
      (shareUser)="openSecondModalShare($event)"
      (addEmail)="openUpdateEmail($event)"
      [columns]="columns"
      [appointments]="rows"
    ></app-appointments-table>
    @if (minorUsers.length > 0) {
      @for (user of minorUsers; track $index) {
        <div>
          <p class="title-minor">{{ 'steps.profileSelection.shareMinor' | translate }} [{{ user.fullName }}]</p>
          <p class="subtitle-minor">{{ 'steps.profileSelection.shareMinorSub' | translate }}</p>
          @if (adultRows) {
            <app-appointments-table
              [hiddenLastSegment]="true"
              [columns]="adultColumns"
              [appointments]="adultRows[$index]"
              (shareUser)="openModalShareMinor($event)"
            ></app-appointments-table>
          }
        </div>
      }
    }
  </div>
</div>
